import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { GasDistributionReports, GasDistributionReportsFilters } from './types';

export const gasDistributionReportsApi = createApi({
  reducerPath: 'gasDistributionReportsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_ANALYTICS_API_URL}/reports/gas-distribution`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  tagTypes: ['GasDistributionReports'],
  endpoints: builder => ({
    getGasDistributionReports: builder.query<
      GasDistributionReports,
      GasDistributionReportsFilters
    >({
      query: filters => ({
        url: `/query`,
        method: 'POST',
        data: filters || {},
      }),
      keepUnusedDataFor: 0,
      providesTags: ['GasDistributionReports'],
    }),
  }),
});

export const { useGetGasDistributionReportsQuery } = gasDistributionReportsApi;
